import { GQLOrderFragment, GQLOrderItemFragment, GQLOrderItemPrintDecorationType, GQLOrderItemPrintFragment } from '@theprintbar/graphql';

export function OrderNeedsScrApproval(order: GQLOrderFragment) {
	return !!order.items?.some(OrderItemNeedsScrApproval);
}

export function OrderItemNeedsScrApproval(orderItem: Pick<GQLOrderItemFragment, 'prints'>) {
	return orderItem.prints?.some(OrderItemDecorationNeedsScrApproval);
}

export function OrderItemDecorationNeedsScrApproval(decoration: GQLOrderItemPrintFragment) {
	return decoration.decoration === GQLOrderItemPrintDecorationType.Scr && !decoration.decorationFile;
}
